import React from 'react'
import Axios from 'axios'
import ReactSelect from 'components/common/ReactSelect'
import { API } from 'api/APIClient'
import AppComponent from 'components/common/AppComponent'
import ModalProgress from 'components/common/ModalProgress'
import moment from 'moment'
import DateHelper from 'utils/DateHelper'
import Modal from 'react-responsive-modal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ChatFlowsSelector from 'components/chatflows/ChatFlowsSelector'
import ChatCustomVariablesSelector from 'components/chatflows/ChatCustomVariablesSelector'
import { NotificationManager } from 'react-notifications'

export default class AgentForm extends AppComponent {

    static defaultProps = {
        item: {}
    }

    static normalizeEntryParams(params) {
        if (!(params instanceof Array)) {
            return [];
        }

        return params.map((param) => {
            let customProperty = null;
            if (param && typeof param.customProperty === "string") {
                customProperty = param.customProperty;
            }
            else if (param && param.customProperty && param.customProperty.key) {
                customProperty = param.customProperty.key;
            }

            return {
                name: param && param.name ? param.name : "",
                customProperty: customProperty,
                required: parseInt(param && param.required) === 1 ? 1 : 0,
                isUserID: parseInt(param && param.isUserID) === 1 ? 1 : 0
            }
        })
    }

    constructor(props, context) {
        super(props);

        const inputItem = props.item || {};
        const item = Object.assign({
            createdAt: "",
            organisationID: context.organisation.id,
            organisationName: context.organisation.name,
            active: 1,
            name: "",
            apiKey: "API Key will be created on submission",
            apiSecret: "API Secret will be created on submission",
            chatFlowID: null,
            chatFlowTitle: "",
            campusID: null,
            userRoleID: null,
            entryParams: []
        }, inputItem);

        if (!item.chatFlowTitle) {
            item.chatFlowTitle = inputItem.chatFlowName || inputItem.defaultChatFlowTitle || "";
        }

        item.entryParams = AgentForm.normalizeEntryParams(inputItem.entryParams);

        this.state = {
            item,
            originalUserIDParam: this.getUserIDParam(item.entryParams),
            organisationOptions: [
                item.organisationID ? {value: item.organisationID, label: item.organisationName || context.organisation.name} : {value: context.organisation.id, label: context.organisation.name}
            ],
            campusOptions: [],
            roleOptions: [],
            validated: false,
            errors: {},
            touched: {},
            isUploading: false,
            modal: {
                isOpen: false,
                content: null,
                size: 'modal-large'
            }
        };
    }

    componentDidMount() {
        this.validate();

        const permissions = this.context.permissions.agent || {};
        if (permissions.allOrgs && !this.state.item.id) {
            this.getOrganisationOptions();
        }

        this.fetchAccessOptions();
    }

    getOrganisationOptions = () => {
        Axios
            .get(API.organisation.getOrganisations, {
                props: {
                    appUsersOnly: 1
                }
            })
            .then((res) => {
                if (res.data.success) {
                    this.setState({
                        organisationOptions: res.data.data.organisations.map((org) => {
                            return { value: org.id.toString(), label: org.name }
                        })
                    })
                }
            })
    }

    fetchAccessOptions = () => {
        if (!this.state.item.organisationID) {
            return;
        }

        Promise
            .all([
                Axios.get(API.agent.getCampuses, {
                    params: {
                        organisationID: this.state.item.organisationID
                    }
                }),
                Axios.get(API.agent.getOrganisationUserRoles, {
                    params: {
                        organisationID: this.state.item.organisationID
                    }
                })
            ])
            .then(([campusesRes, rolesRes]) => {
                const campusOptions = this.parseSimpleOptionsResponse(campusesRes, ["campusOptions", "campuses"]);
                const roleOptions = this.parseSimpleOptionsResponse(rolesRes, ["roles", "userRoles"]);

                this.setState((prevState) => {
                    const nextItem = Object.assign({}, prevState.item);

                    if (nextItem.campusID && !campusOptions.find((o) => o.value.toString() === nextItem.campusID.toString())) {
                        nextItem.campusID = null;
                    }

                    if (nextItem.userRoleID && !roleOptions.find((o) => o.value.toString() === nextItem.userRoleID.toString())) {
                        nextItem.userRoleID = null;
                    }

                    return {
                        campusOptions,
                        roleOptions,
                        item: nextItem
                    }
                }, () => {
                    this.validate();
                })
            })
    }

    parseSimpleOptionsResponse = (res, candidateKeys = []) => {
        if (!res || !res.data || !res.data.success) {
            return [];
        }

        let rows = [];
        const data = res.data.data;

        if (data instanceof Array) {
            rows = data;
        }
        else if (data && typeof data === "object") {
            for (const key of candidateKeys) {
                if (data[key] instanceof Array) {
                    rows = data[key];
                    break;
                }
            }
        }

        return rows.map((row) => {
            return {
                value: row.id,
                label: row.name
            }
        });
    }

    handleSubmit = (event) => {
        event.preventDefault();

        if (!this.state.isUploading) {
            this.setState({
                isUploading: true
            }, () => {
                const payload = {
                    name: this.state.item.name,
                    active: this.state.item.active,
                    organisationID: this.state.item.organisationID,
                    chatFlowID: this.state.item.chatFlowID,
                    campusID: this.state.item.campusID,
                    userRoleID: this.state.item.userRoleID,
                    entryParams: this.state.item.entryParams.map((param) => {
                        return {
                            name: param.name,
                            customProperty: param.customProperty,
                            required: parseInt(param.required) === 1 ? 1 : 0,
                            isUserID: parseInt(param.isUserID) === 1 ? 1 : 0
                        }
                    })
                };

                if (this.state.item.id) {
                    payload.id = this.state.item.id;
                }

                Axios
                    .post(API.agent.submitAgent, payload)
                    .then((res) => {
                        if (res.data.success) {
                            NotificationManager.success(this.state.item.id ? 'Agent updated' : 'Agent created');
                            this.props.onSubmitted(res.data.data.item);
                        }
                        else if (res.data.error) {
                            const errors = Object.assign({}, this.state.errors, {
                                genericError: res.data.error.desc
                            });

                            this.setState({
                                errors
                            });
                        }

                        this.setState({
                            isUploading: false
                        });
                    })
                    .catch((error) => {
                        const errors = Object.assign({}, this.state.errors, {
                            genericError: error && error.response && error.response.data && error.response.data.error ? error.response.data.error.desc : 'Something went wrong'
                        });

                        this.setState({
                            errors,
                            isUploading: false
                        });
                    })
            })
        }
    }

    handleBlur = (event) => {
        const target = event.target;
        const name = target.name;

        const touched = Object.assign({}, this.state.touched, {
            [name]: true
        });

        this.setState({
            touched
        }, () => {
            this.validate()
        })
    }

    handleChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? (target.checked ? 1 : 0) : target.value;
        const name = target.name;

        const item = Object.assign({}, this.state.item);
        item[name] = value;

        if (name === 'organisationID') {
            item.campusID = null;
            item.userRoleID = null;
        }

        this.setState({
            item
        }, () => {
            this.validate();

            if (name === 'organisationID') {
                this.fetchAccessOptions();
            }
        });
    }

    handleEntryParamChange = (index, key, value) => {
        const item = Object.assign({}, this.state.item);
        const entryParams = Array.from(item.entryParams || []);

        if (!entryParams[index]) {
            return;
        }

        entryParams[index] = Object.assign({}, entryParams[index], {
            [key]: value
        });

        if (key === 'isUserID' && parseInt(value) === 1) {
            entryParams.forEach((param, paramIndex) => {
                if (paramIndex !== index) {
                    entryParams[paramIndex] = Object.assign({}, param, {
                        isUserID: 0
                    });
                }
            })
        }

        item.entryParams = entryParams;

        this.setState({
            item
        }, () => {
            this.validate();
        })
    }

    addEntryParam = () => {
        const item = Object.assign({}, this.state.item);
        const entryParams = Array.from(item.entryParams || []);

        entryParams.push({
            name: '',
            customProperty: null,
            required: 0,
            isUserID: 0
        });

        item.entryParams = entryParams;

        this.setState({
            item
        }, () => {
            this.validate();
        })
    }

    removeEntryParam = (index) => {
        const item = Object.assign({}, this.state.item);
        const entryParams = Array.from(item.entryParams || []);

        entryParams.splice(index, 1);
        item.entryParams = entryParams;

        this.setState({
            item
        }, () => {
            this.validate();
        })
    }

    openChatFlowsSelector = () => {
        const selected = [];

        if (this.state.item.chatFlowID) {
            selected.push({
                id: this.state.item.chatFlowID,
                title: this.state.item.chatFlowTitle
            });
        }

        this.openModal(
            <ChatFlowsSelector
                isSingleSelection
                selected={selected}
                onSubmitted={(chatFlow) => {
                    const item = Object.assign({}, this.state.item, {
                        chatFlowID: chatFlow ? chatFlow.id : null,
                        chatFlowTitle: chatFlow ? chatFlow.title : ''
                    });

                    this.setState({
                        item
                    }, () => {
                        this.validate();
                        this.closeModal();
                    })
                }}
                onClose={this.closeModal}
            />,
            'modal-large'
        )
    }

    openCustomPropertySelector = (index) => {
        this.openModal(
            <ChatCustomVariablesSelector
                showSelectButton
                showCopyButton={false}
                onSelected={(property) => {
                    this.handleEntryParamChange(index, 'customProperty', property ? property.key : null);
                    this.closeModal();
                }}
                onCancel={this.closeModal}
            />,
            'modal-large'
        )
    }

    openModal = (content, size = 'modal-large') => {
        this.setState({
            modal: {
                isOpen: true,
                content,
                size
            }
        })
    }

    closeModal = () => {
        this.setState({
            modal: {
                isOpen: false,
                content: null,
                size: 'modal-large'
            }
        })
    }

    getUserIDParam = (entryParams) => {
        if (!(entryParams instanceof Array)) {
            return null;
        }

        return entryParams.find((param) => parseInt(param.isUserID) === 1) || null;
    }

    getUserIDCompareKey = (param) => {
        if (!param) {
            return '';
        }

        if (typeof param.customProperty === 'string' && param.customProperty.length > 0) {
            return `cp-${param.customProperty}`;
        }

        if (param.customProperty && param.customProperty.id) {
            return `cp-${param.customProperty.id}`;
        }

        if (param.customProperty && param.customProperty.key) {
            return `cp-${param.customProperty.key}`;
        }

        if (param.name) {
            return `name-${param.name}`;
        }

        return '';
    }

    isUserIDParamChanged = () => {
        if (!this.state.item.id) {
            return false;
        }

        if (!this.state.originalUserIDParam) {
            return false;
        }

        const current = this.getUserIDParam(this.state.item.entryParams);

        return this.getUserIDCompareKey(this.state.originalUserIDParam) !== this.getUserIDCompareKey(current);
    }

    validate = () => {

        let validated = true;
        const errors = {};

        const item = this.state.item;
        const touched = this.state.touched;

        if (!item.name) {
            if (touched.name) {
                errors.name = 'Name is required';
            }
            validated = false;
        }

        if (!item.organisationID) {
            if (touched.organisationID) {
                errors.organisationID = 'Organisation is required';
            }
            validated = false;
        }

        (item.entryParams || []).forEach((param, index) => {
            if (!param.name || !param.customProperty) {
                validated = false;
                if (touched[`entryParam_${index}`]) {
                    errors[`entryParam_${index}`] = 'Name and Custom Property are required';
                }
            }
        });

        this.setState({
            validated,
            errors
        });
    }

    render() {
        const isEditMode = !!this.state.item.id;

        return (
            <React.Fragment>
                <ModalProgress show={this.state.isUploading} />
                <div className="modal-head">
                    <h3>{isEditMode ? 'Edit Agent' : 'New Agent'}</h3>
                </div>
                <form onSubmit={this.handleSubmit}>
                    <div className="modal-body">
                        <div className="grid-x grid-padding-x">
                            <div className="small-3 cell">
                                <label htmlFor="active" className="text-right middle">Active</label>
                            </div>
                            <div className={"small-9 cell " + (this.state.errors.active && 'error')}>
                                <label className="chkbx-container">
                                    <input className="chkbx" type="checkbox" name="active" onChange={this.handleChange} checked={this.state.item.active === 1} onBlur={this.handleBlur} />
                                    <span className="chkmk"></span>
                                </label>
                            </div>
                        </div>

                        <div className="grid-x grid-padding-x">
                            <div className="small-3 cell">
                                <label htmlFor="createdAt" className="text-right middle">Created At</label>
                            </div>
                            <div className="small-9 cell">
                                <input
                                    name="createdAt"
                                    type="text"
                                    value={this.state.item.createdAt ? moment(DateHelper.convertToLocalDateTime(this.state.item.createdAt), 'YYYY-MM-DD HH:mm:ss').format('LLLL') : ''}
                                    disabled
                                />
                            </div>
                        </div>

                        <div className="grid-x grid-padding-x">
                            <div className="small-3 cell">
                                <label htmlFor="organisationID" className="text-right middle">* Organisation</label>
                            </div>
                            <div className={"small-9 cell " + (this.state.errors.organisationID && 'error')}>
                                <ReactSelect
                                    name="organisationID"
                                    className="react-select"
                                    onChange={this.handleChange}
                                    value={this.state.item.organisationID}
                                    options={this.state.organisationOptions}
                                    onBlur={this.handleBlur}
                                    isDisabled={isEditMode}
                                />
                                <small className="error">{this.state.errors.organisationID}</small>
                            </div>
                        </div>

                        <div className="grid-x grid-padding-x">
                            <div className="small-3 cell">
                                <label htmlFor="name" className="text-right middle">* Name</label>
                            </div>
                            <div className={"small-9 cell " + (this.state.errors.name && 'error')}>
                                <input type="text" name="name" value={this.state.item.name} onChange={this.handleChange} onBlur={this.handleBlur} />
                                <small className="error">{this.state.errors.name}</small>
                            </div>
                        </div>

                        <div className="grid-x grid-padding-x">
                            <div className="small-3 cell">
                                <label htmlFor="apiKey" className="text-right middle">API Key</label>
                            </div>
                            <div className="small-9 cell">
                                <input type="text" name="apiKey" value={isEditMode ? (this.state.item.apiKey || '') : 'API Key will be created on submission'} disabled />
                            </div>
                        </div>

                        <div className="grid-x grid-padding-x">
                            <div className="small-3 cell">
                                <label htmlFor="apiSecret" className="text-right middle">API Secret</label>
                            </div>
                            <div className="small-9 cell">
                                <input type="text" name="apiSecret" value={isEditMode ? (this.state.item.apiSecret || '') : 'API Secret will be created on submission'} disabled />
                            </div>
                        </div>

                        <div className="grid-x grid-padding-x">
                            <div className="small-3 cell">
                                <label htmlFor="chatFlowID" className="text-right middle">Initial Chat Flow</label>
                            </div>
                            <div className="small-9 cell">
                                <div className="input-group">
                                    <input className="input-group-field" type="text" value={this.state.item.chatFlowTitle || 'Please Select'} disabled />
                                    <div className="input-group-button">
                                        <button type="button" className="button" onClick={this.openChatFlowsSelector}>Browse</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="grid-x grid-padding-x">
                            <div className="small-3 cell">
                                <label htmlFor="campusID" className="text-right middle">Default Campus</label>
                            </div>
                            <div className="small-9 cell">
                                <ReactSelect
                                    name="campusID"
                                    className="react-select"
                                    onChange={this.handleChange}
                                    value={this.state.item.campusID}
                                    options={this.state.campusOptions}
                                    isDisabled={!this.state.item.organisationID}
                                />
                                <small className="field-info">New users calling this agent will be assigned to the specified campus</small>
                            </div>
                        </div>

                        <div className="grid-x grid-padding-x">
                            <div className="small-3 cell">
                                <label htmlFor="userRoleID" className="text-right middle">Default User Role ID</label>
                            </div>
                            <div className="small-9 cell">
                                <ReactSelect
                                    name="userRoleID"
                                    className="react-select"
                                    onChange={this.handleChange}
                                    value={this.state.item.userRoleID}
                                    options={this.state.roleOptions}
                                    isDisabled={!this.state.item.organisationID}
                                />
                                <small className="field-info">New users calling this agent will be assigned to the specified user role</small>
                            </div>
                        </div>

                        <div className="grid-x grid-padding-x">
                            <div className="small-12 cell">
                                <fieldset className="fieldset">
                                    <legend>Input parameters</legend>

                                    <div className="grid-x grid-padding-x">
                                        <div className="small-12 cell" style={{marginBottom: 10}}>
                                            <button className="button small" type="button" onClick={this.addEntryParam}>
                                                Add Parameter
                                            </button>
                                        </div>
                                    </div>

                                    {(this.state.item.entryParams || []).map((param, index) => {
                                        return (
                                            <div className="grid-x grid-padding-x align-bottom" key={`entry-param-${index}`}>
                                                <div className="small-12 medium-auto cell">
                                                    <span style={{fontSize: 12}}>Name</span>
                                                    <input
                                                        type="text"
                                                        value={param.name}
                                                        onChange={(e) => this.handleEntryParamChange(index, 'name', e.target.value)}
                                                        onBlur={() => this.setState({ touched: Object.assign({}, this.state.touched, { [`entryParam_${index}`]: true }) }, this.validate)}
                                                    />
                                                </div>

                                                <div className="small-12 medium-4 cell">
                                                    <span style={{fontSize: 12}}>Custom Property</span>
                                                    <div className="input-group">
                                                        <input
                                                            className="input-group-field"
                                                            type="text"
                                                            value={param.customProperty || 'Not Selected'}
                                                            disabled
                                                        />
                                                        <div className="input-group-button">
                                                            <button type="button" className="button" onClick={() => this.openCustomPropertySelector(index)}>Select</button>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="small-12 medium-2 cell">
                                                    <span style={{fontSize: 12}}>Required</span>
                                                    <label className="chkbx-container" style={{marginTop: 8}}>
                                                        <input
                                                            className="chkbx"
                                                            type="checkbox"
                                                            checked={parseInt(param.required) === 1}
                                                            onChange={(e) => this.handleEntryParamChange(index, 'required', e.target.checked ? 1 : 0)}
                                                        />
                                                        <span className="chkmk"></span>
                                                    </label>
                                                </div>

                                                <div className="small-12 medium-2 cell">
                                                    <span style={{fontSize: 12}}>Is User ID?</span>
                                                    <label className="chkbx-container" style={{marginTop: 8}}>
                                                        <input
                                                            className="chkbx"
                                                            type="checkbox"
                                                            checked={parseInt(param.isUserID) === 1}
                                                            onChange={(e) => this.handleEntryParamChange(index, 'isUserID', e.target.checked ? 1 : 0)}
                                                        />
                                                        <span className="chkmk"></span>
                                                    </label>
                                                </div>

                                                <div className="small-12 medium-shrink cell" style={{display: 'flex', alignItems: 'flex-end'}}>
                                                    <button type="button" className="button alert tiny" style={{width: 32, height: 32, padding: 0}} onClick={() => this.removeEntryParam(index)}>
                                                        <FontAwesomeIcon icon="trash" />
                                                    </button>
                                                </div>

                                                {this.state.errors[`entryParam_${index}`] &&
                                                <div className="small-12 cell">
                                                    <small className="error">{this.state.errors[`entryParam_${index}`]}</small>
                                                </div>
                                                }
                                            </div>
                                        )
                                    })}

                                    {this.isUserIDParamChanged() &&
                                    <div className="grid-x grid-padding-x">
                                        <div className="small-12 cell">
                                            <div className="alert-message alert-warning">
                                                If user ID property is changed, all previously saved user IDs will be removed from the database.
                                            </div>
                                        </div>
                                    </div>
                                    }
                                </fieldset>
                            </div>
                        </div>

                        <div className="form-error-msg grid-x grid-padding-x" style={{display: this.state.errors.genericError ? 'block' : 'none'}}>
                            <div className="cell small-12">
                                <span>{this.state.errors.genericError}</span>
                            </div>
                        </div>
                    </div>

                    <div className="modal-footer">
                        <div className="grid-x grid-padding-x">
                            <div className="small-12 cell">
                                <div className="btn-wrap">
                                    <button className="button secondary" type="button" onClick={this.props.onCancel}>
                                        Cancel
                                    </button>
                                    <button className="button success" type="submit" disabled={!this.state.validated}>
                                        Save
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>

                <Modal
                    classNames={{modal: this.state.modal.size}}
                    open={this.state.modal.isOpen}
                    onClose={this.closeModal}
                    center
                >
                    {this.state.modal.content}
                </Modal>
            </React.Fragment>
        );
    }
}
